import { BaseApiClient } from '../base';
import { API_ENDPOINTS } from '../endpoints';

export interface DSRRequest {
  id: string;
  orgId: string;
  requestType: 'erasure' | 'access' | 'rectification' | 'objection';
  subjectIdentifier: string;
  identifierType: 'email' | 'phone' | 'name' | 'external_id';
  status: 'pending' | 'approved' | 'completed' | 'rejected';
  createdAt: string;
  completedAt?: string | null;
  approvedBy?: string | null;
  resultUrl?: string | null;
}

export interface CreateDSRRequest {
  requestType: 'erasure' | 'access' | 'rectification' | 'objection';
  subjectIdentifier: string;
  identifierType: 'email' | 'phone' | 'name' | 'external_id';
}

export class DSRApi extends BaseApiClient {
  async list(params?: {
    status?: string;
    type?: string;
    limit?: number;
    offset?: number;
  }): Promise<{
    data: DSRRequest[];
    meta: { total: number; limit: number; offset: number };
  }> {
    const query = this.buildQuery(params);
    return this.request(`${API_ENDPOINTS.DSR}${query}`);
  }

  async create(data: CreateDSRRequest): Promise<{ data: DSRRequest }> {
    return this.request(API_ENDPOINTS.DSR, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async approve(id: string): Promise<{ data: DSRRequest }> {
    return this.request(API_ENDPOINTS.DSR_APPROVE(id), { method: 'PATCH' });
  }

  async reject(id: string): Promise<{ data: DSRRequest }> {
    return this.request(API_ENDPOINTS.DSR_REJECT(id), { method: 'PATCH' });
  }

  async execute(id: string): Promise<{ data: DSRRequest }> {
    return this.request(API_ENDPOINTS.DSR_EXECUTE(id), { method: 'POST' });
  }

  async delete(id: string): Promise<void> {
    return this.request(API_ENDPOINTS.DSR_BY_ID(id), { method: 'DELETE' });
  }
}
